{
    "welcomeNote": {
        "title": "Welcome to the Petal Editor.",
        "paragraph1": "You can edit the file and publish your changes by clicking the 'Publish File' button.",
        "paragraph2": "Your changes will be published to GitHub in your GitHub repository. After successful publication you will notified with a link to the PR. Happy editing!",
        "buttonLabel": "Don't show again"
    },
    "resultNote": {
        "titleSuccess": "Your changes have been successfully published.",
        "titleError": "Your changes could not be published.",
        "paragraphSuccess": "You can check your published changes here: ",
        "paragraphError": "Something went wrong with publishing your changes because of following error:"
    },
    "info": {
        "returnToReferrer": "Please click here to head back to the referrer page.",
        "contactDocumentationTeam": "Please contact the documentation team, and relay the above error message.",
        "prPushed": "Submitting your PR... Please wait."
    },
    "error": {
        "invalidParameters": {
            "headline": "Invalid Request Parameters",
            "body": "It looks like the parameters in your request are invalid or incomplete. Please refer to the maintainer's documentation for correct usage or contact the developer for further assistance."
        },
        "authenticationError": {
            "headline": "GitHub Integration Required",
            "body": "To proceed, GitHub integration is mandatory. It seems you declined the GitHub authentication request. Please revisit the original documentation, try again, and ensure you accept the GitHub authentication prompt to continue."
        },
        "fileNotFoundError": {
            "headline": "File Not Found",
            "body": "The file you are trying to access does not exist on GitHub or is no longer available. Please contact the documentation maintainer for further clarification and support."
        },
        "incompatibleXditaFile": {
            "headline": "Invalid File Format",
            "body": "The uploaded file is not a valid XDITA file or is malformed. Please verify your file and contact the documentation maintainer for further assistance."
        },
        "toastImageUpload": "Sorry, there was an error with uploading the image. Please check the image and try again.",
        "toastImageInsert": "Sorry, something went wrong with inserting and saving the image.",
        "toastFileUploadInvalid": "Sorry, there was an error with reading the file. Please check if the file you tried to upload contains valid xml and try again",
        "toastFileUpload": "Sorry, something went wrong with opening the file",
        "toastFileUploadNoInput": "Sorry, the editor has problems with opening the file",
        "toastFileDownload": "Apologies, something went wrong in the editor to provide you the download.",
        "toastGitHubPublishNoEditorState": "Sorry, it seems there is nothing in the editor to save and publish. Please try again.",
        "toastGitHubUserEndpoint": "Sorry, an error occured while publishing the document. Please try again. The error: ",
        "toastGitHubToken": "Sorry, an error occured while publishing the document. Please try again. The error: ",
        "toastGitHubPR": "Sorry, an error occured while publishing the document. Please try again. The error: ",
        "GitHubNoPr": "Sorry, an error occured while publishing the document. The error: "
    }
}
